module.exports = __webpack_public_path__ + "img/harry.22dac064.jpg";